module.exports = __webpack_public_path__ + "img/1-4.ff473c13.jpg";